import { render, staticRenderFns } from "./_salesmanItem.vue?vue&type=template&id=f2848b74&"
import script from "./_salesmanItem.vue?vue&type=script&lang=js&"
export * from "./_salesmanItem.vue?vue&type=script&lang=js&"
import style0 from "./_salesmanItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports